module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA3klEQVR4AWOgD7BcRiRC0cBmNSM0w3P6dMW0BN6qCunQdC+gCE4NQLnOXq2vL4Q3r+LT0WR5fF0IyJ48Qw8ojl0D0GygCiCaMYFHQZ5pxQJeCBcojkXDFw3z7VOEISpS4jmEhRgzkjkgXKA4UBaOEBp2LBWAqNi5np+Xl3HfZn4IFyiOogHThs4mbjFRpt5Wbnw2MMzyDO1XgTo6gI2dnSE9CeokoDhQFo4QGtgmOU9eIwVU0d3Epa/LPKUXZANQBCiOXQNEj32WtIgYE9APYhLMbuVyCNWYGohFgxIAAIiuqm/FUSgwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NC.png
// module id = 1224
// module chunks = 0